import { cva } from 'class-variance-authority'

export const badgeVariants = cva(
  'inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
  {
    variants: {
      variant: {
        default: 'border-transparent bg-primary text-primary-foreground hover:bg-primary/80',
        secondary:
          'border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80',
        destructive:
          'border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80',
        outline: 'text-foreground',
        tab: 'border-transparent bg-emerald-600 text-white dark:bg-emerald-600 dark:text-white',
        overlay:
          'border-transparent bg-white/90 text-foreground backdrop-blur-sm shadow-sm hover:bg-white dark:bg-black/70 dark:text-white dark:border-white/10',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
)
